import { render } from "./LogoShimmerComponent.vue?vue&type=template&id=fc4fcf76&ts=true"
import script from "./LogoShimmerComponent.vue?vue&type=script&lang=ts"
export * from "./LogoShimmerComponent.vue?vue&type=script&lang=ts"

import "./LogoShimmerComponent.vue?vue&type=style&index=0&id=fc4fcf76&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__